import { Component, ViewEncapsulation, Input, Output, EventEmitter, Injector } from '@angular/core';

import { Grid2Component } from './grid2.component';
import { Column } from './column';

import { GenericService } from '../../services/generic/generic.service';

@Component({
    selector: 'grid-rest',
    template: '<grid2 [columns]="columns" [cellLink]="cellLink" [displayFilter]="displayFilter"></grid2>',
    encapsulation: ViewEncapsulation.None
})

export class GridRestComponent extends Grid2Component {

    protected genericService: GenericService;
    @Input() public restPath: string = '';
    @Input() public loadOnScroll: Boolean = true;
    @Input() public page: number = 0;
    public ended: Boolean = false;
    public filterField: string = '';

    constructor(injector: Injector) {
        super(injector);
        this.genericService = injector.get(GenericService);
    }

    ngAfterViewInit() {
        this.load();
    }

    onScroll($event: any) {
        if (this.loadOnScroll && this.platform.isBrowser) {
            if ((!this.loading) && ((window.innerHeight + window.scrollY) >= document.body.offsetHeight)) {
                this.loadMore();
            }
        }
    }

    public handleKeyDown(event: any) {
        if (event.keyCode === 13) {
            this.onSearch();
        }
    }

    public onSearch() {
        this.filter(this.searchField);
    }

    public load() {
        this.loading = true;
        this.genericService.restPath = this.restPath;
        this.genericService.getItems(this.page, this.limit, this.filterField).subscribe(res => {
            if (res.length > 0) {
                this.rows = res;
            } else {
                this.ended = true;
            }
            this.loading = false;
        });
    }

    public loadMore() {
        if (!this.ended) {
            this.page = this.page + 1;
            this.loading = true;
            this.genericService.restPath = this.restPath;
            this.genericService.getItems(this.page, this.limit, this.filterField).subscribe(res => {
                if (res.length > 0) {
                    this.rows = this.rows.concat(res);
                } else {
                    this.ended = true;
                }
                this.loading = false;
            });
        }
    }

    public filter(filterField: string) {
        this.filterField = filterField;
        this.page = 0;
        this.loading = true;
        this.genericService.restPath = this.restPath;
        this.genericService.getItems(this.page, this.limit, this.filterField).subscribe(res => {
            if (res.length > 0) {
                this.rows = res;
            } else {
                this.ended = true;
            }
            this.loading = false;
        });
    }
}